import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icons-img/clip.svg'


const _withScopeId = n => (_pushScopeId("data-v-26728d4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  for: "input-field",
  class: "input-box full-screen"
}
const _hoisted_2 = { class: "input-box-text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-plus" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 1,
  for: "input-field",
  class: "d-input-box full-screen"
}
const _hoisted_9 = { class: "d-input-box-text" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-pin",
  src: _imports_0,
  alt: "icon"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_add_menu_pop_up = _resolveComponent("message-add-menu-pop-up")!
  const _component_app_take_photo = _resolveComponent("app-take-photo")!
  const _component_app_message_photo_selector = _resolveComponent("app-message-photo-selector")!
  const _component_app_message_file_selector = _resolveComponent("app-message-file-selector")!
  const _component_app_message_case_selector = _resolveComponent("app-message-case-selector")!
  const _component_message_photo_selector_pop_up = _resolveComponent("message-photo-selector-pop-up")!
  const _component_message_file_selector_pop_up = _resolveComponent("message-file-selector-pop-up")!
  const _component_app_upload_info = _resolveComponent("app-upload-info")!
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_desktop_message_photo_selector = _resolveComponent("desktop-message-photo-selector")!
  const _component_desktop_message_file_selector = _resolveComponent("desktop-message-file-selector")!
  const _component_desktop_message_case_selector = _resolveComponent("desktop-message-case-selector")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showAddMenu && _ctx.showAddMenu(...args)), ["prevent"])),
            class: "input-box-add-menu"
          }, _hoisted_4),
          _withDirectives(_createElementVNode("textarea", {
            ref: "input",
            id: "input-field",
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.message) = $event)),
            onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"])),
            onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
            onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
            disabled: _ctx.disabled
          }, null, 40, _hoisted_5), [
            [
              _vModelText,
              _ctx.message,
              void 0,
              { trim: true }
            ]
          ]),
          _createElementVNode("span", {
            class: _normalizeClass(["input-field__icon icon icon-send2", { 'input-field__icon--active': _ctx.message }]),
            onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSend && _ctx.onSend(...args)), ["prevent"]))
          }, null, 2)
        ]),
        _withDirectives((_openBlock(), _createElementBlock("input", {
          ref: "mediaInputRef",
          key: _ctx.mediaLoadedKey,
          onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addMedia($event))),
          accept: "image/png, image/jpg, image/jpeg, video/*",
          capture: "environment",
          type: "file",
          disabled: _ctx.disabled
        }, null, 40, _hoisted_6)), [
          [_vShow, false]
        ]),
        _withDirectives(_createElementVNode("input", {
          ref: "phoneMedia",
          accept: "image/png, image/jpg, image/jpeg",
          type: "file",
          onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addMedia($event))),
          disabled: _ctx.disabled
        }, null, 40, _hoisted_7), [
          [_vShow, false]
        ]),
        (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
          _createVNode(_component_message_add_menu_pop_up, {
            ref: "addMenuPopUp",
            onOpenTakePhoto: _ctx.openTakePhoto,
            onOpenDrive: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showMediaSelector = true)),
            onHandleOpenPhoneMedia: _ctx.openPhoneMedia,
            onOpenCase: _ctx.shareCase,
            onOpenFileList: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showFileSelector = true)),
            onUploadFile: _ctx.uploadFile
          }, null, 8, ["onOpenTakePhoto", "onHandleOpenPhoneMedia", "onOpenCase", "onUploadFile"]),
          _createVNode(_component_app_take_photo, {
            ref: "takePhoto",
            image: _ctx.mediaToCrop,
            labels: _ctx.labels,
            onOnCancel: _ctx.handleMediaCancel,
            onOnDone: _ctx.handleMediaDone,
            onOnRetake: _ctx.handleRetake,
            "done-btn-text": "app.take.photo.send.button",
            "done-btn-icon": "icon-send2",
            singleUpload: "",
            hideOptionsList: "",
            showLabels: "",
            isCaseCropper: ""
          }, null, 8, ["image", "labels", "onOnCancel", "onOnDone", "onOnRetake"]),
          (_ctx.showMediaSelector)
            ? (_openBlock(), _createBlock(_component_app_message_photo_selector, {
                key: 0,
                isGroup: _ctx.isGroup,
                onDone: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showMediaSelector = false)),
                onCancel: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showMediaSelector = false))
              }, null, 8, ["isGroup"]))
            : _createCommentVNode("", true),
          (_ctx.showFileSelector)
            ? (_openBlock(), _createBlock(_component_app_message_file_selector, {
                key: 1,
                isGroup: _ctx.isGroup,
                onDone: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showFileSelector = false)),
                onCancel: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showFileSelector = false))
              }, null, 8, ["isGroup"]))
            : _createCommentVNode("", true),
          (_ctx.showCaseSelector)
            ? (_openBlock(), _createBlock(_component_app_message_case_selector, {
                key: 2,
                isGroup: _ctx.isGroup,
                onDone: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showCaseSelector = false)),
                onCancel: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showCaseSelector = false))
              }, null, 8, ["isGroup"]))
            : _createCommentVNode("", true),
          _createVNode(_component_message_photo_selector_pop_up, {
            ref: "mediaSelectorPopUp",
            onOpenDrive: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showMediaSelector = true)),
            onHandleOpenPhoneMedia: _ctx.openPhoneMedia
          }, null, 8, ["onHandleOpenPhoneMedia"]),
          _createVNode(_component_message_file_selector_pop_up, {
            ref: "fileSelectorPopUp",
            onOpenFileList: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showFileSelector = true)),
            onUploadFile: _ctx.uploadFile
          }, null, 8, ["onUploadFile"]),
          (_ctx.mediaUploading)
            ? (_openBlock(), _createBlock(_component_app_loader, {
                key: 3,
                message: _ctx.loaderText
              }, {
                default: _withCtx(() => [
                  (_ctx.mediaUploading && _ctx.uploadInfo.total)
                    ? (_openBlock(), _createBlock(_component_app_upload_info, {
                        key: 0,
                        "upload-info": _ctx.uploadInfo,
                        onCancelUpload: _ctx.cancelUpload
                      }, null, 8, ["upload-info", "onCancelUpload"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["message"]))
            : _createCommentVNode("", true)
        ]))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
        _createElementVNode("label", _hoisted_9, [
          _createElementVNode("div", {
            onClick: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showAddMenu && _ctx.showAddMenu(...args)), ["prevent"])),
            class: "d-input-box-add-menu"
          }, _hoisted_11),
          _withDirectives(_createElementVNode("textarea", {
            class: "text-input",
            ref: "input",
            id: "input-field",
            type: "text",
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.message) = $event)),
            onKeydown: _cache[20] || (_cache[20] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["prevent"]), ["enter"])),
            onInput: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.autosize && _ctx.autosize(...args))),
            onFocus: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
            disabled: _ctx.disabled
          }, null, 40, _hoisted_12), [
            [
              _vModelText,
              _ctx.message,
              void 0,
              { trim: true }
            ]
          ]),
          _createElementVNode("span", {
            class: _normalizeClass(["input-field__icon icon icon-send2", { 'input-field__icon--active': _ctx.message }]),
            onClick: _cache[23] || (_cache[23] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSend && _ctx.onSend(...args)), ["prevent"]))
          }, null, 2)
        ]),
        _withDirectives((_openBlock(), _createElementBlock("input", {
          ref: "mediaInputRef",
          key: _ctx.mediaLoadedKey,
          onInput: _cache[24] || (_cache[24] = ($event: any) => (_ctx.addMedia($event))),
          accept: "image/png, image/jpg, image/jpeg",
          capture: "environment",
          type: "file",
          disabled: _ctx.disabled
        }, null, 40, _hoisted_13)), [
          [_vShow, false]
        ]),
        _withDirectives(_createElementVNode("input", {
          ref: "phoneMedia",
          accept: "image/png, image/jpg, image/jpeg",
          type: "file",
          onInput: _cache[25] || (_cache[25] = ($event: any) => (_ctx.addMedia($event))),
          disabled: _ctx.disabled
        }, null, 40, _hoisted_14), [
          [_vShow, false]
        ]),
        (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
          _createVNode(_component_message_add_menu_pop_up, {
            ref: "addMenuPopUp",
            onOpenTakePhoto: _ctx.openTakePhoto,
            onOpenDrive: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showMediaSelector = true)),
            onHandleOpenPhoneMedia: _ctx.openPhoneMedia,
            onOpenCase: _ctx.shareCase,
            onOpenFileList: _cache[27] || (_cache[27] = ($event: any) => (_ctx.showFileSelector = true)),
            onUploadFile: _ctx.uploadFile
          }, null, 8, ["onOpenTakePhoto", "onHandleOpenPhoneMedia", "onOpenCase", "onUploadFile"]),
          _createVNode(_component_app_take_photo, {
            ref: "takePhoto",
            image: _ctx.mediaToCrop,
            labels: _ctx.labels,
            onOnCancel: _ctx.handleMediaCancel,
            onOnDone: _ctx.handleMediaDone,
            onOnRetake: _ctx.handleRetake,
            "done-btn-text": "app.take.photo.send.button",
            "done-btn-icon": "icon-send2",
            singleUpload: "",
            hideOptionsList: "",
            showLabels: "",
            isCaseCropper: ""
          }, null, 8, ["image", "labels", "onOnCancel", "onOnDone", "onOnRetake"]),
          (_ctx.showMediaSelector)
            ? (_openBlock(), _createBlock(_component_desktop_message_photo_selector, {
                key: 0,
                isGroup: _ctx.isGroup,
                onDone: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showMediaSelector = false)),
                onCancel: _cache[29] || (_cache[29] = ($event: any) => (_ctx.showMediaSelector = false))
              }, null, 8, ["isGroup"]))
            : _createCommentVNode("", true),
          (_ctx.showFileSelector)
            ? (_openBlock(), _createBlock(_component_desktop_message_file_selector, {
                key: 1,
                isGroup: _ctx.isGroup,
                onDone: _cache[30] || (_cache[30] = ($event: any) => (_ctx.showFileSelector = false)),
                onCancel: _cache[31] || (_cache[31] = ($event: any) => (_ctx.showFileSelector = false))
              }, null, 8, ["isGroup"]))
            : _createCommentVNode("", true),
          (_ctx.showCaseSelector)
            ? (_openBlock(), _createBlock(_component_desktop_message_case_selector, {
                key: 2,
                isGroup: _ctx.isGroup,
                onDone: _cache[32] || (_cache[32] = ($event: any) => (_ctx.showCaseSelector = false)),
                onCancel: _cache[33] || (_cache[33] = ($event: any) => (_ctx.showCaseSelector = false))
              }, null, 8, ["isGroup"]))
            : _createCommentVNode("", true),
          _createVNode(_component_message_photo_selector_pop_up, {
            ref: "mediaSelectorPopUp",
            onOpenDrive: _cache[34] || (_cache[34] = ($event: any) => (_ctx.showMediaSelector = true)),
            onHandleOpenPhoneMedia: _ctx.openPhoneMedia
          }, null, 8, ["onHandleOpenPhoneMedia"]),
          _createVNode(_component_message_file_selector_pop_up, {
            ref: "fileSelectorPopUp",
            onOpenFileList: _cache[35] || (_cache[35] = ($event: any) => (_ctx.showFileSelector = true)),
            onUploadFile: _ctx.uploadFile
          }, null, 8, ["onUploadFile"]),
          (_ctx.mediaUploading)
            ? (_openBlock(), _createBlock(_component_app_loader, {
                key: 3,
                message: _ctx.loaderText
              }, {
                default: _withCtx(() => [
                  (_ctx.mediaUploading && _ctx.uploadInfo.total)
                    ? (_openBlock(), _createBlock(_component_app_upload_info, {
                        key: 0,
                        "upload-info": _ctx.uploadInfo,
                        onCancelUpload: _ctx.cancelUpload
                      }, null, 8, ["upload-info", "onCancelUpload"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["message"]))
            : _createCommentVNode("", true)
        ]))
      ]))
}